import { Routes } from '@angular/router';
import { AuthGuard } from '../../../abraj-shared/src/lib/guards/auth.guard';
import { ViewRoutes } from './views/views.routing';

export const routes: Routes = [
    {
            path:'',loadComponent:()=> import('./views/views.component').then(m => m.DashboardComponent ),children: ViewRoutes,canActivate: [AuthGuard],
        }
];``
